import { Alert, Box, Button, Tooltip, Typography } from "@mui/material";
import axios from 'axios';
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { IState } from "../../../redux/reducers/rootReducers";
import parse from 'html-react-parser';
import { getArticlesById } from "../../../redux/actions/KnowledgeBase/article";
import { triggerAppAlert } from "../../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import FullscreenExitOutlinedIcon from '@mui/icons-material/FullscreenExitOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
const ArticleSuggestion = memo(({modalInfo=null, ticketStatuses=[], callback}:any) => {
    const dispatch = useDispatch();
    const {ticketInfo, suggestions=[], isSSP, contact, agent} = modalInfo || {};
    const articleBodyRef =  useRef<any>(null);
    const [articleBody, setArticleBody] = useState<any>(null);
    const [textCopied, setTextCopied] = useState<any>(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const selectedTabRef = useRef("");
    const onCloseHandler = useCallback((feedbackType?:string) => {
        // console.log('onCloseHandler', ticketStatuses, ticketInfo);
        const statusId = (ticketStatuses || []).find((i: any) => i.name === 'Resolved')?.id ?? ticketInfo?.ticketLogs?.statusId ?? null;

        setActiveIndex(0);
        setArticleBody(null);
        if(callback) callback(feedbackType, statusId,ticketInfo,selectedTabRef?.current);
    }, [])


    const getArticleBody = (articleId: number, index: number = 0) => {
        const getArticlesByIdCB = (resStatus: any, res: any) => {
            // console.log('getArticlesByIdCB', res)
            selectedTabRef.current = res.name
            if (resStatus === "0") {
                setActiveIndex(index);
                setArticleBody(res);
            }
        }
        setArticleBody(null);
        setTextCopied(false);
        
      dispatch(getArticlesById(articleId, getArticlesByIdCB,isSSP))
    }

    useEffect(() => {
        if (ticketInfo && suggestions.length > 0) {
            getArticleBody(suggestions[0].id);
        }else{
            setActiveIndex(0);
            setArticleBody(null);
        }
    }, [modalInfo?.ticketInfo]);

    const feedbackHandler = (type: string) => {
        const feedback = type === "like" ? 1 : 0;
        const userType = isSSP ? "/user/article/usage/ssp" : "/article/usage/Agent";
        axios.put(process.env.REACT_APP_TEST_API_URL + `${userType}/${articleBody?.id}/${feedback}`, { articleId: articleBody?.id, feedback }).then((res) => {
            onCloseHandler(type);
            dispatch(triggerAppAlert('Thank you for your feedback!', 'success'));
        })
    }
    const copyToClipboard = async () => {
        if (!articleBodyRef.current || textCopied) return;

        const content = articleBodyRef.current.innerText;

        try {
            await navigator.clipboard.writeText(`${articleBody?.name} \n ${content}`);
            dispatch(triggerAppAlert('Article copied to clipboard!', 'success'));
            setTextCopied(true);
        } catch (err) {
        console.error('Failed to copy: ', err);
        }
    };
    return (<>
        <Box className="modal-body">
            <Box className="p-1">

                {ticketInfo && suggestions.length > 0 ?
                    <Box>
                        <Box className="article-suggestion">
                            <Box className="article-suggestion-title">
                                <Alert severity="info" >
                                    Before we move forward, take a look at these related articles. They might solve your issue right away!
                                </Alert>

                            </Box>
                            {/* <Button onClick={onCloseHandler}> close</Button> */}
                            {suggestions.length > 1 ? <Box>
                                <Box className="article-suggestion-article d-flex gap5">
                                    {suggestions.map((item:any, index:number) => (<>
                                        <Tooltip key={item?.id} title={item.name} placement="top">
                                        <Box onClick={() => getArticleBody(item.id, index)} key={item.id} className={`tabButtons truncate ${activeIndex === index ? "active" : ""}`}>{item?.articleName}</Box>
                                        </Tooltip>
                                    </>))}
                                </Box>
                            </Box> : null}

                            {suggestions.length > 0 ? <Box>
                                <Typography component="h2" variant="h6" gutterBottom className="article-suggestion-article-title">
                                    <span>{articleBody?.name}</span>
                                    <Button onClick={copyToClipboard}><ContentCopyIcon />{textCopied ? "Copied" : "Copy Article"} </Button>
                                </Typography>
                                <hr />
                                <Box ref={articleBodyRef} className="article-suggestion-article">
                                    {parse(articleBody?.body || '')}
                                </Box>
                            </Box> : null}


                        </Box>
                    </Box>
                    : null}


            </Box>
        </Box>
        <Box className="modal-footer">
            <Box className="text-right p-1">
                {articleBody && 
                    <Box className="article-suggestion-actions d-flex gap15 justify-content-end align-items-center">
                        <span>Was this article helpful? </span>
                        <Button onClick={() => feedbackHandler('like')} color="success"><span className="simple-icon icon-like"></span></Button>
                        <Button onClick={() => feedbackHandler('dislike')} color="error"><span className="simple-icon icon-dislike"></span></Button>
                    </Box>
                }
            </Box>
        </Box>
    </>)
})

export const SuggestionModalActions = ({modalInfo}:any) => {
    const dispatch = useDispatch();
    const toggleFullScreenArticle = (fullScreen:boolean) => {
        dispatch({
            type: 'UPDATE_TICKET_VIEW_ARTICLE_MODAL',
            payload: fullScreen
        });
    }
    return (
        <>
        {modalInfo && modalInfo.ticketInfo &&
            <Typography
                className="cursor-pointer"
                onClick={()=>toggleFullScreenArticle(modalInfo?.fullScreen ? false : true)}
            >
                {modalInfo?.fullScreen ?
                    <FullscreenExitOutlinedIcon  className="cursor-pointer" />
                :
                    <FullscreenOutlinedIcon  className="cursor-pointer" />
                }
            </Typography>
        }
        </>
    );
}

const mapStateToProps = (state:IState) => {
  return ({
    modalInfo : state?.TicketViewReducer?.articleModal,
    ticketStatuses : state?.TicketsReducer?.allResponses.ticketStatus
  })
};

export default connect(mapStateToProps)(ArticleSuggestion);